import { STOP_LOADING,START_LOADING } from './actionTypes';
import { getAllLocationGroups, saveLocationGroups, updateLocationGroups,deletelocationGroupsById, getlocationGroups } from '../../services/locationGroupServices';
import { openSessionTimeoutModal } from './sessionTimeOutActions';


 export const saveLocationGroupsAction = (formData) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'SAVE_LOCATION_GROUPS' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await saveLocationGroups(formData, token);
    dispatch({ type: STOP_LOADING, service: 'SAVE_LOCATION_GROUPS' });
    dispatch({ type: 'SAVE_LOCATION_GROUPS_SUCCESS', payload: response });

    return response; 
  } catch (error) {
    if (error?.includes("403")) {
      dispatch(openSessionTimeoutModal());
    } else {
      dispatch({ type: STOP_LOADING, service: 'SAVE_LOCATION_GROUPS' });
      dispatch({
        type: 'SAVE_LOCATION_GROUPS_FAILURE',
        payload: error || 'Save location service failed.',
      });
    }
    throw error; 
  }
};


    export const updateLocationGroupsAction = (formData,callbackfn) => async (dispatch, getState) => {


      try {
        dispatch({ type: START_LOADING, service: 'START_LOADING' });
        const token = getState().auth.token || sessionStorage.getItem("token");;
        const response = await updateLocationGroups(formData, token);
        dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
        if (response) {
          callbackfn(response);
        }
        dispatch({ type: 'UPDATE_LOCATION_GROUPS_SUCCESS', payload: response });
      } catch (error) {
        dispatch({ type: 'GET_LOCATION_GROUPS_FAILURE', payload: error || 'All location service failed. Please try again.' });
      }
    };

    export const getAllLocationGroupsAction= (page = 0, size = 5) => async (dispatch, getState) => {
      try {
        dispatch({ type: START_LOADING, service: 'START_LOADING' });
        const token = getState().auth.token || sessionStorage.getItem("token");
        const response = await getAllLocationGroups(token, page, size);

        dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
        dispatch({ type: 'ALL_LOCATION_GROUPS', payload: response });
      } catch (error) {
        dispatch({ type: 'GET_LOCATION_GROUPS_FAILURE', payload: error || 'All location service failed. Please try again.' });
      }
    };

    export const deleteGrouplocationAction = (id) => async (dispatch, getState) => {
      try {
        dispatch({ type: 'START_DELETE_LOADING' }); 
        const token = getState().auth.token || sessionStorage.getItem("token");
        await deletelocationGroupsById(token, id); 
        dispatch({ type: 'DELETE_GROUP_LOCATIONS', payload: id });

        dispatch(getAllLocationGroupsAction()); 

        dispatch({ type: 'STOP_DELETE_LOADING' }); 
      } catch (error) {
        dispatch({ type: 'GET_LOCATION_GROUPS_FAILURE', payload: error || 'Failed to delete group. Please try again.' });
        dispatch({ type: 'STOP_DELETE_LOADING' }); 
      }
    };

   export const getAllLocationGroupsListAction= (page = 0, size = 100) => async (dispatch, getState) => {
      try {
        dispatch({ type: START_LOADING, service: 'START_LOADING' });
        const token = getState().auth.token || sessionStorage.getItem("token");
        const response = await getlocationGroups(token, page, size);
        dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
        dispatch({ type: 'GET_ALL_LOCATION_GROUPS_LIST_SUCCESS', payload: response });
      } catch (error) {
        dispatch({ type: 'GET_ALL_LOCATION_GROUPS_LIST_FAILURE', payload: error || 'All group location service failed. Please try again.' });
      }
    };